import { Platform } from 'src/environment';
import { asyncLoadLibrary } from 'src/shared/utilities/asyncLoadLibrary';

export function loadTealium(): void {
  const { platform, brand, tealiumEnvironment } = window.ghsConfiguration;
  const url = `https://tags.tiqcdn.com/utag/grubhubseamless/${brand.toLowerCase()}/${tealiumEnvironment}/utag.js`;

  if (platform === Platform.WEB) {
    window._utq = window._utq || [];

    asyncLoadLibrary({
      id: 'gh-tealium',
      url,
      attributes: { async: '' },
      isAppend: false,
      onLoad: () => {
        logTealiumEntries(...window._utq);
        setUpTealiumQueue();
      },
    });
  }
}

function setUpTealiumQueue() {
  window._utq.push = (
    ...entries: Array<TealiumViewPayload | TealiumLinkPayload>
  ) => {
    logTealiumEntries(...entries);

    for (let i = 0; i < entries.length; i++) {
      window._utq[window._utq.length] = entries[i];
    }

    return window._utq.length;
  };
}

function logTealiumEntries(
  ...entries: Array<TealiumLinkPayload | TealiumViewPayload>
) {
  if (window.utag) {
    entries.forEach((entry) => {
      if ((entry as TealiumViewPayload).pageGroup) {
        window.utag.view(entry as TealiumViewPayload);
      } else {
        window.utag.link(entry as TealiumLinkPayload);
      }
    });
  }
}
